/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-21
 * @description Implementation of the GraphQL query to retrieve a featured entity details.
 * @filename featured-entity-query.tsx
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL query to retrieve the featured entity with an id.
 *
 * @type {GraphQLTaggedNode}
 */
export const FEATURED_ENTITY_QUERY: GraphQLTaggedNode = graphql`
  query featuredEntityQuery($id: ID!) {
    entity(id: $id) {
      hasErrors
      entity {
        __typename
        description
        id
        landingPageUrl
        name
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                id
                files {
                  id
                  name
                  path
                }
                topLevelMediaType {
                  kind
                  label
                }
              }
            }
          }
        }
        revision
        websiteUrl
      }
    }
  }
`;
